import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\node_modules\\next-intl\\dist\\esm\\production\\navigation\\shared\\BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\node_modules\\next-intl\\dist\\esm\\production\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ActionForm"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\src\\components\\admin\\ActionForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfirmSubmit"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\src\\components\\ConfirmSubmit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StayGallery"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\src\\components\\StayGallery.tsx");
